export const stringEnumValidator = <T extends Record<string, string>>(enumToValidateAgainst: T) => (
  value?: string
): value is T[keyof T] => Object.values(enumToValidateAgainst).some((enumValue) => enumValue === value);
